import ApiClient from '../../../../../resources/js/apiClient'

class ApiService {
  constructor (config) {
    this.http = new ApiClient(config)
  }

  /**
   * Запрос к API на получение списка логинов
   * @returns {Promise<AxiosResponse<T>>}
   */
  getLoginsData () {
    return this.http.get('/api/context/logins')
  }

  /**
   * Запрос к API на получение данных для графика на странице статистики
   * @param from Начало периода
   * @param to Конец периода
   * @param directLogin Логин в Директе
   * @returns {Promise<AxiosResponse<T>>}
   */
  getStatisticsChartsData (from, to, directLogin) {
    const params = {
      from,
      to
    }
    if (directLogin) {
      params.directLogin = directLogin
    }
    return this.http.get('/api/context/statistics/charts', { params })
  }

  /**
   * Запрос к API на получение данных для итогов на странице статистики
   * @param from Начало периода
   * @param to Конец периода
   * @param directLogin Логин в Директе
   * @returns {Promise<AxiosResponse<T>>}
   */
  getStatisticsTotalsData (from, to, directLogin) {
    const params = {
      from,
      to
    }
    if (directLogin) {
      params.directLogin = directLogin
    }
    return this.http.get('/api/context/statistics/totals', { params })
  }

  /**
   * Запрос к API на получение общей информации
   * @param from Начало периода
   * @param to Конец периода
   * @param directLogin Логин в Директе
   * @returns {Promise<AxiosResponse<T>>}
   */
  getMainData (from, to, directLogin) {
    const params = {
      from,
      to
    }
    if (directLogin) {
      params.directLogin = directLogin
    }
    return this.http.get('/api/context/main', { params })
  }

  /**
   * Запрос к API на получение данных для графика на странице сводки
   * @param from Начало периода
   * @param to Конец периода
   * @param filterBy Фильтр
   * @param directLogin Логин в Директе
   * @returns {Promise<AxiosResponse<T>>}
   */
  getBriefChartsData (from, to, filterBy, directLogin) {
    const params = {
      from,
      to,
      filterBy
    }
    if (directLogin) {
      params.directLogin = directLogin
    }
    return this.http.get('/api/context/brief/charts', { params })
  }

  /**
   * Запрос к API на получение данных для таблицы на странице сводки
   * @param from Начало периода
   * @param to Конец периода
   * @param directLogin Логин в Директе
   * @returns {Promise<AxiosResponse<T>>}
   */
  getBriefTableData (from, to, directLogin) {
    const params = {
      from,
      to
    }
    if (directLogin) {
      params.directLogin = directLogin
    }
    return this.http.get('/api/context/brief/table', { params })
  }

  /**
   * Запрос к API на получение списка документов для авторизованного клиента
   * @returns {Promise<AxiosResponse<T>>}
   */
  getDocumentsData () {
    return this.http.get('/api/context/documents')
  }

  /**
   * Возвращает файловый поток для ZIP-архива
   * @param id
   * @returns {Promise<AxiosResponse<T>>}
   */
  getArchiveForDownload (id) {
    const params = { id }
    return this.http.get('/api/context/download', { params })
  }

  /**
   * Возвращает файловый поток для конкретного файла
   * @param id
   * @returns {Promise<AxiosResponse<T>>}
   */
  getFileForDownload (id) {
    const params = { id }
    return this.http.get('/api/context/download/file', { params })
  }

  /**
   * Возвращает содержимое конкретного файла для просмотра
   * @param id
   * @returns {Promise<AxiosResponse<T>>}
   */
  getFileForPreview (id) {
    const params = { id }
    return this.http.get('/api/context/preview/file', { params })
  }
}

export default new ApiService({
  responseType: 'json'
})
